// Dummy placeholder for CSS
export default class TabScroller {
}
//# sourceMappingURL=index.js.map